<template>
  <card class="level-progress">
    <AdminTitle title="首付比评级" size="20px" />
    <div class="step-box">
      <div
        class="final-level"
        v-if="finalLevelItem"
        :style="{
          left: finalLeft + '%',
          backgroundColor: finalColor,
        }"
      >
        <p>首付比评级：{{ finalLevel }}级</p>
        <p>最终首付比：{{ finalPrepayRateText }}</p>
        <i class="el-icon-caret-bottom" :style="{ color: finalColor }"></i>
      </div>
      <div
        v-for="item in levelList"
        :key="item.name"
        :style="{ backgroundColor: item.color }"
        class="level-item"
      >
        {{ item.name }}级
      </div>
    </div>
  </card>
</template>

<script>
import { PrepayLevelList, getPrepayLevelColor } from "@/enum/dict";

export default {
  name: "LevelProgressV2",
  props: {
    // 最终首付比等级，支持 A～E。
    finalLevel: {
      type: String,
      default: "",
    },
    // 首付比支持数字和数字字符串，缺失时显示 --%。
    finalPrepayRate: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      // 复制档位配置，避免多个实例共享响应式对象。
      levelList: PrepayLevelList.map((item) => ({ ...item })),
    };
  },
  computed: {
    // 查找最终等级的位置，未知等级不展示标注。
    finalLevelIndex() {
      return this.levelList.findIndex((item) => item.name === this.finalLevel);
    },
    // 位置和颜色共用已匹配的档位。
    finalLevelItem() {
      return this.levelList[this.finalLevelIndex] || null;
    },
    // 等宽档位的中心点，随档位数量计算。
    finalLeft() {
      return this.finalLevelItem
        ? ((this.finalLevelIndex + 0.5) / this.levelList.length) * 100
        : 0;
    },
    // 与首付比环共用等级配色。
    finalColor() {
      return getPrepayLevelColor(
        this.finalLevelItem ? this.finalLevelItem.name : "",
      );
    },
    // 保留实际首付比，空白和非有限数值显示占位符。
    finalPrepayRateText() {
      const rate = this.finalPrepayRate;
      if (
        rate === null ||
        rate === undefined ||
        (typeof rate === "string" && rate.trim() === "")
      )
        return "--%";
      const num = Number(rate);
      return Number.isFinite(num) ? String(num) + "%" : "--%";
    },
  },
};
</script>
<style lang="scss" scoped>
.level-progress /deep/ {
  box-sizing: border-box;
  border-color: transparent;
  margin-top: 20px;
  border-radius: 16px;
  .ivu-card-body {
    display: flex;
    flex-direction: column;
    .final-level {
      position: absolute;
      color: #fff;
      font-size: 14px;
      padding: 10px 20px;
      display: flex;
      flex-direction: column;
      top: -18px;
      white-space: nowrap;
      transform: translateY(-100%) translateX(-50%);
      border-radius: 10px;
      min-width: 100px;
      .el-icon-caret-bottom {
        position: absolute;
        bottom: -9px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .step-box {
      position: relative;
      margin-top: 80px;
    }
    > div {
      display: flex;
      justify-content: space-between;
    }
    .level-item {
      display: flex;
      color: #fff;
      flex: 1;
      min-width: 0;
      margin-right: 2px;
      height: 36px;
      justify-content: center;
      font-size: 16px;
      align-items: center;
      position: relative;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
